import { render } from "./ImportContrat.vue?vue&type=template&id=2eed51d3"
import script from "./ImportContrat.vue?vue&type=script&lang=ts"
export * from "./ImportContrat.vue?vue&type=script&lang=ts"
script.render = render

export default script